
import "@styles/loadingPage.scss";
import React from "react";
import { I18n } from "../../../../i18n/i18n";

interface Props {
  i18n: I18n;
}

export class LoadingPageComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { i18n } = this.props;

    return (
      <div className="v-main-cont">
        <div>
          <div className="head-text"> {i18n.loadingPageMainMsg} </div>
          <div className="v-cam-img-cont">
            <img className="v-cam-img" src="public/images/cam.gif" alt="camera icon"/>
          </div>
          <p className="v-info-text">{i18n.loadingPageDetails}</p>
        </div>
      </div>);
  }
}
